module.exports = __webpack_public_path__ + "static/media/temperature-empty.9327e6f5.svg";